import { z } from "zod";

export enum InsuranceCardSide {
  BACK = "back",
  FRONT = "front",
  UNSPECIFIED = "unspecified",
}

export enum InsuranceCardSource {
  EHR = "ehr",
  PAYER = "payer",
}

export const insuranceCardImageSideSchema = z.object({
  side: z.enum(InsuranceCardSide),
  mediaType: z.string().min(1),
  contentBase64: z.string().min(1),
});

export const insuranceCardViewSchema = z.object({
  source: z.enum(InsuranceCardSource),
  sides: z.array(insuranceCardImageSideSchema).min(1),
});

export const insuranceCardResponseSchema = z.object({
  card: insuranceCardViewSchema.nullable(),
});

export type InsuranceCardImageSide = z.infer<typeof insuranceCardImageSideSchema>;
export type InsuranceCardView = z.infer<typeof insuranceCardViewSchema>;
export type InsuranceCardResponse = z.infer<typeof insuranceCardResponseSchema>;
